import React, { useState } from "react";

import "./itemsBalance.scss";
import { useSelector } from "react-redux";

const ItemsBalance = ({ companyBalance }) => {
  const [showCredit, setShowCredit] = useState(true);
  const countrySetting = useSelector((state) => state.countrySetting);

  const toggleSaldo = () => setShowCredit(!showCredit);

  return (
    <>
      <div className={"items-balance-container"}>
        {/* <button
          onClick={toggleSaldo}
          className={"items-balance-btn btn primary"}
        >
          {showCredit ? "Mostrar Prepago" : "Mostrar Crédito"}
        </button> */}
        <div className={"items-balance-content"}>
          <div className="items__balance">
            <p>
              <span>SALDO DE</span> PREPAGO
            </p>
            <h4>
              {countrySetting.currency}
              {Number(companyBalance.prepaidBalance).toLocaleString(
                countrySetting.cultureCode,
                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
              )}
            </h4>
          </div>
          <div className="items__balance">
            <p>
              <span>SALDO A</span> CRÉDITO
            </p>
            <h4>
              {countrySetting.currency}
              {Number(companyBalance.creditBalance).toLocaleString(
                countrySetting.cultureCode,
                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
              )}
            </h4>
          </div>

          {/* <p>
            {showCredit
              ? "Saldo de compañía a crédito"
              : "Saldo de compañía de prepago"}
          </p> */}
        </div>
      </div>
    </>
  );
};

export default ItemsBalance;
